import StageOne from "./Stages/StageOne";
import StageTwo from "./Stages/StageTwo";

import connectWithDispatch from "../../../Hooks/connectWithDispatch";

interface CharacterProps {
  stage: number;
}

const Character = (props: CharacterProps) => {
  const { stage } = props;

  return (
    <>
      {stage === 1 && <StageOne />}
      {stage === 2 && <StageTwo />}
    </>
  );
};

const mapStateToProps = (state: StateType) => {
  return {
    stage: state.appReducer.story.stage,
  };
};

export default connectWithDispatch(Character, mapStateToProps);
